import type { SVGProps } from 'react';

export function RabbyIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7.837 18.331c-2.925-.098-4.87-1.283-4.972-3.185-3.021 0-1.888-3.39 0-3.083 4.027-6.905 9.859-4.932 12.271-3.082.504-.74 1.259-1.336 1.573-1.542-15.418-5.548-1.658-9.508 5.035 1.85 2.883 4.892.438 4.992-3.631 5.158a84 84 0 0 0-1.718.082 22 22 0 0 1-1 1.463c-.934-.309-1.823-.489-2.438-.429.252-1.48-.315-2.671-.63-3.082.504.986.21 2.877 0 3.699 1.044 0 1.896.177 2.577.446 1.987.786 2.521 2.362 2.143 2.637-.394.286-.716.112-1.153-.123-.409-.22-.918-.494-1.679-.494-.442 0-.828-.006-1.172-.015a28 28 0 0 1-2.257-.154c-.71-.072-1.374-.14-2.549-.14q-.203 0-.4-.006m-.93.78c3.218-.157 3.218.26 5.292.26-4.725 3.881-9.043 3.185-5.292-.26" />
    </svg>
  );
}
